// AffiliateProductCardList.jsx

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import apiClient from "../api/apiClient";

const AffiliateProductCardList = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    apiClient
      .get("/admin/aff/active")
      .then((res) => setProducts(res.data))
      .catch((err) => console.error("Error fetching products:", err));
  }, []);

  return (
    <div className="container" style={{ paddingTop: "120px" }}>
      <h2 className="mb-4 text-center">Featured Affiliate Products</h2>
      <div style={{ margin: '20px 0', fontSize: '14px', color: '#555' }}>
  <strong>Disclosure:</strong> This post contains affiliate links; 
  if you make a purchase through them, I may earn a small commission—at no extra cost to you.
</div>

      <div className="row">
        {products.map((product) => (
          <div key={product.id} className="col-md-4 mb-4">
            <div className="card h-100 shadow-sm">
              <img
                src={product.imageUrls?.[0] || "/placeholder.jpg"}
                className="card-img-top p-3"
                alt={product.title}
                style={{ height: "250px", objectFit: "contain" }}
              />
              <div className="card-body d-flex flex-column">
                <h6 className="card-title">{product.title}</h6>
                <p className="card-text text-muted ">{product.brand}</p>
                <p className="mt-auto">
                  <span className="badge bg-danger mb-2 mr-2">
                    {Math.round(
                      ((product.originalPrice - product.price) /
                        product.originalPrice) *
                      100
                    )}
                    % OFF
                  </span>

                  <span className="card-text text-muted price">
                    <span className="rupee">₹</span>
                    <span className="text-decoration-line-through">{new Intl.NumberFormat('en-IN').format(product.originalPrice?.toFixed(2))}</span>
                  </span>
                </p>
                <p className="card-text fw-bold mt-auto price">
                    <span className="rupee">₹</span>{new Intl.NumberFormat('en-IN').format(product.price?.toFixed(2))}
                  </p>
                <Link
                  to={`/affiliate/${product.id}`}
                  className="btn btn-primary mt-auto"
                >
                  View Details
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AffiliateProductCardList;
